import _ from "lodash"
import { setValue, getGridSpanStyles } from "../";
import { styles } from '../../constantsv3'

export const getDefaultValuesv3 = (pluginType: string, deviceType: string, parentId: string) => {
  const a8Window: any = window;
  const plugin = a8Window[pluginType];

  if(pluginType === "SnackBar"){
    styles.Sm.widthMode = "px"
    styles.Sm.width = "335"
  }else if(pluginType === "FAB"){
    styles.Sm.widthMode = "px"
    styles.Sm.width = "40"
  }else{
    styles.Sm.widthMode = "%"
    styles.Sm.width = "100"
  }
  const defaultValues: any = {
    properties: {
      styles,
      config: {
        visible: true,
      }
    }
  };

  const pluginDataWithoutStyles = _.cloneDeep(plugin?.data?.json || {});
  if (pluginDataWithoutStyles?.properties?.styles) {
      delete pluginDataWithoutStyles.properties.styles;
  }
  const mergedDefaults = _.merge(
    {},
    defaultValues,
    pluginDataWithoutStyles || {}
  );

  if (plugin?.data) {
    const { config = {} } = plugin.data;
    Object.keys(config).forEach((key) => {
      const field = config[key];
      let path = (field.key || field.section) + "." + key;
      path = path.replace(/\$deviceType/g, deviceType)
      setValue(mergedDefaults, path.split("."), field.default, deviceType);
    });
  }

  return mergedDefaults;
};
